module.exports = __webpack_public_path__ + "img/round-chat_bubble-24px.966eb593.svg";